<template>
  <button
    class="navigational-item navigational-item--gray navigational-item--dark-blue"
    @click="signOut()">
    <oie-use-svg svg="user" css-classes="navigation-item__icon"></oie-use-svg>{{ tStatic('signOutMenuItem') }}
  </button>
</template>

<script>
export default {}
</script>
